(ns dashboard.views.login.events
  (:require [dashboard.notifications :as notifications]
            [dashboard.services.http-config :as http-config]
            [re-frame.core :as rf]))

(rf/reg-event-db
 ::set-login-form-type
 (fn [db [_ type values]]
   (-> (assoc-in db [:login :form-type] type)
       (assoc-in [:login :form type] values))))

(rf/reg-event-db
 ::update-login-form-values
 (fn [db [_ type values]]
   (update-in db [:login :form type] merge values)))

(rf/reg-event-fx
 ::login
 (fn [{:keys [db]} [_ username password]]
   {:db (assoc-in db [:login :form :login :loading] true)
    :http-xhrio {:method          :post
                 :uri             "/authentication/login/"
                 :timeout         http-config/timeout
                 :format          http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :params          {:username username :password password}
                 :on-success      [::login-successful]
                 :on-failure      [::login-failed username]}}))

(rf/reg-event-fx
 ::login-successful
 (fn [{:keys [db]} [_]]
   {:db (-> db
            (assoc-in [:login :form :login :loading] false)
            (update-in [:login :form :login] dissoc :error))
    :fx [[:dispatch [:dashboard.core/initialize-user-session]]
         [:dispatch [::notifications/add {:message "Logged in successfully"}]]]}))

(rf/reg-event-fx
 ::login-failed
 (fn [{:keys [db]} [_ username {:keys [status response]}]]
   {:db (cond-> (assoc-in db [:login :form :login :loading] false)
          true (assoc-in [:login :form :login :username] username)

          (= (-> response :type) :user-not-found)
          (assoc-in [:login :form :login :error] "Incorrect email")

          (= (-> response :type) :password-reset-required)
          (-> (assoc-in [:login :form-type] :forgot-password)
              (assoc-in [:login :form :forgot-password :username] username)
              (assoc-in [:login :form :forgot-password :note] "You need to reset your password."))

          (= (-> response :type) :incorrect-email-or-password)
          (assoc-in [:login :form :login :error] (or (:message response) "Incorrect email or password"))

          (= (-> response :type) :challenge-required)
          (-> (assoc-in [:login :form-type] :challenge)
              (assoc-in [:login :form :challenge] (merge {:username username}
                                                         (dissoc response :type)))))

    :fx (if (= status 200) ; hack due to re-frame-http-fx failing on HTTP 200
          [[:dispatch [::login-successful]]]
          [])}))

(rf/reg-event-fx
 ::forgot-password
 (fn [{:keys [db]} [_ username]]
   {:db (assoc-in db [:login :form :forgot-password :loading] true)
    :http-xhrio {:method          :post
                 :uri             "/authentication/forgot-password"
                 :timeout         http-config/timeout
                 :format          http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :params          {:username username}
                 :on-success      [::forgot-password-successful username]
                 :on-failure      [::forgot-password-failed username]}}))

(rf/reg-event-fx
 ::forgot-password-successful
 (fn [{:keys [db]} [_ username response]]
   {:db (assoc-in db [:login :form :forgot-password :loading] false)
    :dispatch [::set-login-form-type :confirm-forgot-password (merge {:username username
                                                                      :confirmation-code ""}
                                                                     response)]}))

(rf/reg-event-fx
 ::forgot-password-failed
 (fn [{:keys [db]} [_ username {:keys [status response]}]]
   {:db (assoc-in db [:login :form :forgot-password :loading] false)
    :dispatch (case status
                ; hack due to re-frame-http-fx failing on HTTP 200
                200 [::forgot-password-successful username response]
                400 (case (:type response)
                      :limit-exceeded [::update-login-form-values :forgot-password {:error "Attempt limit exceeded. Please try again after some time."}]
                      (do
                        (println "unhandled forgot password HTTP 400 error response: " response)
                        [::notifications/add {:message "Password reset failed"}]))
                401 (case (:type response)
                      :user-not-found [::update-login-form-values :forgot-password {:error (str "User with email " username " not found")}]
                      :not-authorized [::update-login-form-values :forgot-password {:error (:message response)}]
                      (do
                        (println "unhandled forgot password HTTP 401 error response: " response)
                        [::notifications/add {:message "Password reset failed"}]))
                :else (do
                        (println "unhandled forgot password error status: " status " " response)
                        [::notifications/add {:message "Password reset failed"}]))}))

(rf/reg-event-fx
 ::confirm-forgot-password
 (fn [{:keys [db]} [_ username password confirmation-code]]
   {:db (assoc-in db [:login :form :confirm-forgot-password :loading] true)
    :http-xhrio {:method          :post
                 :uri             "/authentication/confirm-forgot-password"
                 :timeout         http-config/timeout
                 :format          http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :params          {:username username
                                   :password password
                                   :confirmation-code confirmation-code}
                 :on-success      [::confirm-forgot-password-successful username password]
                 :on-failure      [::confirm-forgot-password-failed username password]}}))

(rf/reg-event-fx
 ::confirm-forgot-password-successful
 (fn [{:keys [db]} [_ username password]]
   {:db (assoc-in db [:login :form :confirm-forgot-password :loading] false)
    :fx [[:dispatch [::notifications/add {:message "Your new password is now in use"}]]
         [:dispatch [::login username password]]]}))

(rf/reg-event-fx
 ::confirm-forgot-password-failed
 (fn [{:keys [db]} [_ username password {:keys [status response]}]]
   {:db (assoc-in db [:login :form :confirm-forgot-password :loading] false)
    :dispatch (case status
                ; hack due to re-frame-http-fx failing on HTTP 200
                200 [::confirm-forgot-password-successful username password response]
                400 (case (:type response)
                      :code-mismatch [::update-login-form-values :confirm-forgot-password {:error "Incorrect verification code."}]
                      :expired-code [::update-login-form-values :confirm-forgot-password {:error "Your verification code has expired. Try to resend the code."}]
                      ;; NOTE: preferably we should never end up here, we should always validate
                      ;; password before attempting the reset.
                      :invalid-password [::update-login-form-values :confirm-forgot-password {:error (:message response)}]
                      :limit-exceeded [::update-login-form-values :confirm-forgot-password {:error "Attempt limit exceeded. Please try again after some time."}]
                      (do
                        (println "unhandled confirm forgot password error response: " response)
                        [::notifications/add {:message "Password reset failed"}]))
                (do
                  (println "unhandled confirm forgot password error status: " status " " response)
                  [::notifications/add {:message "Password reset failed"}]))}))

(rf/reg-event-fx
 ::respond-to-challenge
 (fn [{:keys [db]} [_ {:keys [challenge new-password user-code code]}]]
   {:db (assoc-in db [:login :form :challenge :loading] true)
    :http-xhrio {:method          :post
                 :uri             "/authentication/challenge"
                 :timeout         http-config/timeout
                 :format          http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :params          (case challenge
                                    :new-password-required (let [{:keys [username session]} (-> db :login :form :challenge)]
                                                             {:challenge :new-password-required
                                                              :username username
                                                              :new-password new-password
                                                              :session session})
                                    :register-mfa (let [{:keys [session]} (-> db :login :form :challenge)]
                                                    {:challenge :register-mfa
                                                     :session session
                                                     :user-code user-code})
                                    :mfa (let [{:keys [username session]} (-> db :login :form :challenge)]
                                           {:challenge :mfa
                                            :session session
                                            :username username
                                            :code code})
                                    (throw (js/Error. (str "Unknown challenge: " challenge))))
                 :on-success      [::respond-to-challenge-successful]
                 :on-failure      [::respond-to-challenge-failed]}}))

(rf/reg-event-fx
 ::respond-to-challenge-successful
 (fn [{:keys [db]} [_ {:keys [challenge] :as data}]]
   {:db (cond-> (assoc-in db [:login :form :challenge :loading] false)
          (#{:register-mfa :register-mfa-success} challenge)
          (-> (assoc-in [:login :form-type] :challenge)
              (assoc-in [:login :form :challenge] data))

          (= :mfa-success challenge)
          (dissoc db :login))
    :fx (case challenge
          :new-password-required
          [[:dispatch [:dashboard.core/initialize-user-session]]
           [:dispatch [::notifications/add {:message "Your new password is now in use"}]]]

          :register-mfa-success
          [[:dispatch [::notifications/add {:message "MFA association succesfull, please login"}]]]

          :mfa-success
          [[:dispatch [:dashboard.core/initialize-user-session]]
           [:dispatch [::notifications/add {:message "MFA Login succesfull"}]]]

          [])}))

(rf/reg-event-fx
 ::respond-to-challenge-failed
 (fn [{:keys [db]} [_ {:keys [status response]}]]
   (let [response-type (:type response)]
     (if (= status 200)
       {:dispatch [::respond-to-challenge-successful]}
       {:db (cond-> (assoc-in db [:login :form :challenge :loading] false)
              (#{:not-authorized :invalid-password :associate-mfa-failure :mfa-failure} response-type)
              (assoc-in [:login :form :challenge :error] (:message response)))
        :fx (case response-type
              :invalid-password
              [[:dispatch [::notifications/add {:message "Failed to set new password"}]]]

              :associate-mfa-failure
              [[:dispatch [::notifications/add {:message "Failed to associate MFA device"}]]]

              :mfa-failure
              [[:dispatch [::notifications/add {:message "MFA Login failed"}]]]

              [])}))))

(rf/reg-event-fx
 ::resend-confirmation-code
 (fn [{:keys [db]} [_ username]]
   {:db (assoc-in db [:login :form :confirm-forgot-password :resend-loading] true)
    :dispatch [::forgot-password username]}))
